import * as types from '../../action-types';
import {deleteEmergencyContact as initialState } from "../../initialState";

const deleteEmergencyContact = (state=initialState, action) => {
  switch (action.type) {
    case types.DELETE_EMERGENCY_CONTACT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.DELETE_EMERGENCY_CONTACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.DELETE_EMERGENCY_CONTACT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.DELETE_EMERGENCY_CONTACT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default deleteEmergencyContact;
